import { useEffect, useState } from "react";
import { FaSolarPanel, FaPlug } from "react-icons/fa";
import { getRangeSummary } from "../services/rangeSummary";

import "../styles/rangeSummaryCard.css";

const RANGE_LABELS = {
    today: "Today",
    yesterday: "Yesterday",
    week: "Last 7 Days",
    month: "This Month",
    lastmonth: "Last Month",
    year: "This Year"
};

// Drop this into Reports.jsx as:
//   <RangeSummaryCard serial={activeSerial} range={range} />
// - reuses whatever "range" state your dropdown already has,
// no new date-picker/state needed.
export default function RangeSummaryCard({ serial, range }) {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {

        if (!serial) return;

        setLoading(true);
        setError("");

        getRangeSummary(serial, range)
            .then(res => setData(res.data))
            .catch(err => {
                console.error(err);
                setError("Couldn't load totals for this period.");
            })
            .finally(() => setLoading(false));

    }, [serial, range]);

    return (

        <div className="rangeSummaryCard">

            <h3>Totals - {RANGE_LABELS[range] || range}</h3>

            {loading ? (

                <div className="rangeSummaryEmpty">Loading...</div>

            ) : error ? (

                <div className="rangeSummaryEmpty">{error}</div>

            ) : !data || Number(data.days_with_data) === 0 ? (

                <div className="rangeSummaryEmpty">No data for this period yet.</div>

            ) : (

                <div className="rangeSummaryGrid">

                    <div className="rangeSummaryStat">
                        <div className="rangeSummaryIcon solar"><FaSolarPanel /></div>
                        <div>
                            <span>Total PV Production</span>
                            <b>{Number(data.total_solar_kwh).toFixed(2)} kWh</b>
                        </div>
                    </div>

                    <div className="rangeSummaryStat">
                        <div className="rangeSummaryIcon grid"><FaPlug /></div>
                        <div>
                            <span>Total Grid Energy</span>
                            <b>{Number(data.total_grid_kwh).toFixed(2)} kWh</b>
                        </div>
                    </div>

                </div>

            )}

        </div>

    );

}
